import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api"; // Assuming you have an api module to make API requests
import { MY_PHARMACY_LIST } from "../../services/urls"; // Assuming you have a URL for fetching teams
import { getPharmacyId, setPharmacyId } from "../../utils/commonFunctions";

// Initial state
const initialState = {
  phamracyList: [],
};

// Async thunk to fetch teams
export const myPharmacyList = createAsyncThunk(
  "pharmacy/myPharmacyList", // Action type prefix
  async (updateStorage = true, { rejectWithValue }) => {
    try {
      const response = await api.get(MY_PHARMACY_LIST);
      const list = response?.data?.data || [];
      if (list.length && updateStorage) {
        const currentId = getPharmacyId();
        const stillValid =
          currentId && list.some((p) => String(p._id) === String(currentId));
        // Always seed pharmacyId when missing/stale so scoped APIs never hit "//all"
        if (!stillValid) {
          setPharmacyId(list[0]._id);
        }
      }
      return list;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch teams"
      );
    }
  }
);

// Create slice
const pharmacySlice = createSlice({
  name: "pharmacy",
  initialState,
  reducers: {
    clearPharmacyList: (state) => {
      state.phamracyList = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(myPharmacyList.fulfilled, (state, action) => {
      state.phamracyList = action.payload;
    });
  },
});
export const { clearPharmacyList } = pharmacySlice.actions;
// Export the reducer
export default pharmacySlice.reducer;
